import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
